/**
 * Deep G: a double row of boulders over a long slime bed, a gallery under the bed, and five
 * butterflies in cells under slime taps in the gallery floor. Run the dirt row under the boulders
 * and they fall behind you, seep into the gallery and on through the taps onto the butterflies
 * (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepG: CaveDef = {
  id: 'G',
  name: 'FILTER BEDS',
  hint: 'Run under the boulders. The slime will do the rest.',
  intermission: false,
  colors: [9, 3, 5],
  diamondValue: 20,
  extraValue: 32,
  fill: { base: '.', items: [['r', 11], ['d', 4]] },
  levels: [
    { seed: 5701, diamonds: 18, time: 150 },
    { seed: 5702, diamonds: 22, time: 140 },
    { seed: 5703, diamonds: 26, time: 130 },
    { seed: 5704, diamonds: 30, time: 120 },
    { seed: 5705, diamonds: 34, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??????????????????????????????????????W',
    'W...rrrdrrrrrdrrrrrdrrrrrdrrrrrdrrrr...W',
    'W...rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr...W',
    'WP.....................................W',
    'W..wssssssssssssssssssssssssssssssssw..W',
    'W...                                ...W',
    'W..wwwwswwwwwswwwwwswwwwwswwwwwswwwww..W',
    'W..wwww wwwww wwwww wwwww wwwww wwwww..W',
    'W..wwwwbwwwwwbwwwwwbwwwwwbwwwwwbwwwww..W',
    'W..wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww..W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W???????????????????????????????????...W',
    'W???????????????????????????????????.X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
